import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import TakeoverDetail from './TakeoverDetail';

const goBackOr = (navigate, fallback) => {
  if (typeof window !== 'undefined' && window.history.length > 1) {
    navigate(-1);
    return;
  }
  navigate(fallback);
};

const TakeoverDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [takeover, setTakeover] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    const takeoverId = String(id || '').trim();
    if (!takeoverId) {
      setTakeover(null);
      setError('Missing takeover id');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const snap = await getDoc(doc(db, 'orders', takeoverId));
      if (!snap.exists()) {
        setTakeover(null);
        setError('Takeover not found');
        return;
      }
      setTakeover({ id: snap.id, ...snap.data() });
    } catch (e) {
      setTakeover(null);
      setError(e?.message || 'Failed to load takeover');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const close = () => goBackOr(navigate, '/takeovers');

  return (
    <div className="f-page-enter mx-auto max-w-4xl px-4 pb-8">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <h1 className="f-title mb-0">Takeover Details</h1>
          <p className="f-subtitle mb-0 mt-1">{id}</p>
        </div>
        <button type="button" className="f-button f-button-secondary" onClick={close}>
          Back
        </button>
      </div>

      {loading && (
        <div className="f-card" style={{ padding: 40, textAlign: 'center', color: 'var(--ms-text-secondary)' }}>
          Loading takeover…
        </div>
      )}

      {!loading && error && (
        <div className="f-card" style={{ padding: 40, textAlign: 'center' }}>
          <div style={{ color: '#d13438', marginBottom: 12 }}>{error}</div>
          <button type="button" className="f-button" onClick={() => navigate('/takeovers')}>
            View all takeovers
          </button>
        </div>
      )}

      {!loading && takeover && (
        <div className="takeover-detail-page f-card" style={{ padding: 0, overflow: 'hidden' }}>
          <TakeoverDetail takeover={takeover} refreshTakeover={load} onClose={close} />
        </div>
      )}
    </div>
  );
};

export default TakeoverDetailPage;
